/** Shared modal CSS classes — import from here, never hardcode. */

import { bgLayer1 } from './layerClasses';

/** Section container — layer-1 surface (same as `tableCardClass`) so all top-level
 *  cards/sections read consistently. */
export const sectionBox = `${bgLayer1} rounded-xl border border-border-subtle dark:border-border-subtle-dark shadow-sm`;
export const sectionBoxP4 = `${sectionBox} p-4`;
export const sectionBoxP6 = `${sectionBox} p-6`;

/** Section heading — always with icon at left via `flex items-center gap-2` */
export const sectionHeading = 'text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider flex items-center gap-2';

/** Inner card — read-only data groups inside sections */
export const innerCard = 'rounded-lg border border-border-subtle dark:border-border-subtle-dark bg-slate-50 dark:bg-slate-800/50 px-3 py-2';

/** Dashed divider between subsections */
export const dashedDivider = 'border-t border-dashed border-border-subtle dark:border-border-subtle-dark';
